<template>
  <LayoutSite>
    <Formulario titulo="Importação de Prazos">
      <v-card flat class="mx-auto">
        <v-card-title>
          <h4>Para importar, siga os passos abaixo:</h4>
          <v-spacer></v-spacer>
          <v-btn depressed color="default" @click="VisualizarDistribuicao()" v-if="!isCalculista" >Distribuição</v-btn>
        </v-card-title>
        <v-card-text>
          <ol>
            <li>
              Crie um arquivo com os prazos a serem importados (
              <a href="Modelo.xls">Modelo</a>)
            </li>
            <li>Selecione o arquivo</li>
            <li>Confira se os dados estão corretos</li>
            <li>Clique em Validar</li>
            <li>Clique em Importar</li>
          </ol>
          <v-row>
            <v-col cols="3">
              <v-label></v-label>
              <vue-xlsx-table @on-select-file="handleSelectedFile">
                <b>SELECIONE UM ARQUIVO</b>
                <v-icon dark style="margin-top:-4px">mdi-cloud-upload</v-icon>
              </vue-xlsx-table>
            </v-col>
          </v-row>

          <v-data-table :headers="headers" :items="items" locale="pt-BR">
            <template v-slot:item="props">
              <tr>
                <td class="text-left">{{props.item.EMPRESA}}</td>
                <td class="text-left">{{props.item.ESCRITORIO}}</td>
                <td class="text-left">{{props.item.ADVOGADO}}</td>
                <td class="text-left">{{props.item.EMAIL_ADVOGADO }}</td>
                <td class="text-left">{{props.item.COMARCA }}</td>
                <td class="text-left">{{props.item.RECLAMANTE }}</td>
                <td class="text-left">{{props.item.RECLAMADA }}</td>
                <td class="text-left">{{props.item.TIPO_PRAZO }}</td>
                <td class="text-left">{{props.item.SOLICITACAO }}</td>
                <td class="text-left">{{props.item.DATA_FATAL }}</td>
                <td class="text-left">{{props.item.RESPONSAVEL }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>

        <v-alert
          dense
          outlined
          type="error"
          v-for="(erro, index) of erros"
          :key="index"
        >{{linha}} {{erro[0]}}</v-alert>

        <v-alert
          dense
          outlined
          type="success"
          v-for="(msg, index) of mensagens"
          :key="index"
        >{{msg[0]}}</v-alert>

        <v-card-actions>
          <v-btn depressed color="warning" @click="limpar()" v-if="validado">limpar</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="primary"
            @click="validar()"
            :disabled="!validado"
            v-if="!importa"
          >VALIDAR</v-btn>
          <v-btn depressed color="primary" @click="Salvar()" v-if="importa">importar</v-btn>
        </v-card-actions>
      </v-card>
    </Formulario>
    <!-- Distribuição -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="distribuicao" max-width="600">
          <Distribuicao></Distribuicao>
        </v-dialog>
      </v-row>
    </template>
  </LayoutSite>
</template>

<script>
import LayoutSite from "@/components/layout/LayoutSite";
import Formulario from "@/components/Form";
import Distribuicao from "@/components/Distribuicao";

export default {
  data() {
    return {
      validado: false,
      importa: false,
      sucesso: false,
      distribuicao: false,
      isCalculista: false,
      mensagens: [],
      erros: [],
      linha: "",
      headers: [
        { text: "Empresa", value: "empresa" },
        { text: "Escritorio", value: "escritorio" },
        { text: "Advogado", value: "advogado" },
        { text: "Email", value: "email_advogado" },
        { text: "Comarca", value: "comarca" },
        { text: "Reclamente", value: "reclamante" },
        { text: "Reclamada", value: "reclamada" },
        { text: "Tipo Prazo", value: "tipo_prazo" },
        { text: "Solicitação", value: "solicitacao" },
        { text: "Data Fatal", value: "data_fatal" },
        { text: "Responsável", value: "responsavel" }
      ],
      items: []
    };
  },
  components: {
    LayoutSite,
    Formulario,
    Distribuicao
  },
  created() {
    let usuario = this.$store.getters.getUsuario;
    this.isCalculista = usuario.perfil_id == 3;
  },
  methods: {
    handleSelectedFile(convertedData) {
      this.limpar();

      if (convertedData.header.length == 16) {
        this.items = convertedData.body;
        this.validado = true;
      } else {
        this.erros.push([
          "Arquivo Inválido! Verifique se todos os campos foram preenchidos."
        ]);
        return;
      }
    },
    VisualizarDistribuicao() {
      this.distribuicao = !this.distribuicao;
    },
    limpar() {
      this.validado = false;
      this.importar = false;
      this.items = [];
      this.erros = [];
      this.mensagens = [];
      this.sucesso = false;
    },
    validar() {
      this.importa = true;

      for (let index = 0; index < this.items.length; index++) {
        this.items[index].INSERIR = 0;
        this.items[index].LINHA = index + 2;
        this.items[index].DT_FATAL = this.parseDate(
          this.items[index].DATA_FATAL
        );
        this.items[index].DT_SOLICITACAO = this.parseDate(
          this.items[index].DATA_SOLICITACAO
        );

        this.$http
          .post(this.$urlAPI + "/importar", this.items[index], {
            headers: { authorization: "Bearer " + this.$store.getters.getToken }
          })
          .then(response => {
            if (!response.data.status) {
              this.linha = "Linha " + this.items[index].LINHA + ": ";
              this.erros = response.data.erros;
              this.importa = false;
              index = this.items.length;
            }
          })
          .catch(e => {
            this.linha = "Linha " + this.items[index].LINHA + ": ";
            this.erros = e.response.data.erros;
            this.importa = false;
            index = this.items.length;
          });
      }
    },
    Salvar() {
      this.sucesso = true;

      for (let index = 0; index < this.items.length; index++) {
        this.items[index].INSERIR = 1;
        this.items[index].LINHA = index + 2;
        this.items[index].DT_FATAL = this.parseDate(
          this.items[index].DATA_FATAL
        );
        this.items[index].DT_SOLICITACAO = this.parseDate(
          this.items[index].DATA_SOLICITACAO
        );

        this.$http
          .post(this.$urlAPI + "/importar", this.items[index], {
            headers: { authorization: "Bearer " + this.$store.getters.getToken }
          })
          .then(response => {
            if (!response.data.status) {
              this.linha = "Linha " + this.items[index].LINHA + ": ";
              this.erros = response.data.erros;
              this.sucesso = false;
              index = this.items.length;
            }
          })
          .catch(e => {
            this.linha = "Linha " + this.items[index].LINHA + ": ";
            this.erros = response.data.erros;
            this.sucesso = false;
            index = this.items.length;
          });
      }

      if (this.sucesso) {
        this.limpar();
        this.mensagens.push(["Prazos Importados com Sucesso!"]);
      }
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  }
};
</script>
